const NewsList2024 = [
    {
        dt: "March",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Naga_Jyothi_RSC.jpg",
        title: "Congratulations to Ms. M.S.V. Naga Jyothi",
        desc: "Ms M.S.V. Naga Jyothi, a PhD scholar from the Department of Civil and Environmental Engineering, has secured the Runner-up position in the Environmental Category at the 10th RSC (Royal Society of Chemistry) Global Online Poster Conference, held on the LinkedIn platform on March 4-5, 2025."
    },
    {
        dt: "December",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/COPEN_13_Best_Paper_Awards.pdf",
        title: "Congratulations to Dr. Govind Narayan Sahu",
        desc: "Dr. Govind Narayan Sahu, Assistant Professor of Mechanical Engineering at IIT Tirupati, received 'Best Paper Award' for the paper titled 'Emulating lobes and lenses in turning process using hardware-in-the-loop experiments' at the 13th International Conference on Precision, Meso, Micro and Nano Engineering (COPEN 13),  December 13 - 15 , 2024."

    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/vajitha_award_ce21d501.jpg",
        title: "Congratulations to Ms. Vajitha G",
        desc: "Ms. Vajitha G, a Ph.D. scholar in Civil and Environmental Engineering, has been awarded First Prize for her project titled: 'A Continuous Flow Membrane-Modified Capacitive Deionization (MCDI) for Clean Drinking Water' under the Health Science category. This achievement was recognized at the All Indian Universities (AIU) ANVESHAN 2025 – International Research Student Convention, held at Chitkara University, Chandigarh on March 10 & 11, 2025."

    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/CSE_MTECH_NEW.jpg",
        title: "Data Science and Artificial Intelligence'",
        desc: "Department of Computer Science and Engineering introduces a new stream in M.Tech programme - 'Data Science and Artificial Intelligence' from the Academic year 2025-26."
    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/MA_MSC_MATHS.jpg",
        title: "M.Sc. In Mathematics",
        desc: "Department of Mathematics and Statistics introduces a new programme - 'M.Sc. in Mathematics' from the Academic year 2025-26."
    },
    {
        dt: "January",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/NPTEL_Public_Organization_and_Management_2025.png",
        title: "NPTEL course entitled 'Public Organization and Management'",
        desc: "Dr. Vaneet Kashyap from the HSS Department is offering an NPTEL course entitled 'Public Organization and Management'. The aim of the course is to introduce learners to various themes of managing public organisations and provide them with a greater depth of research and theory about public management. Intended audience: UG and PG students, civil servants, people working in government, public, and private sector organisations, and faculty teaching courses in general and public management."
    },
    {
        dt: "December",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/AFSTI_Travel_award.jpg",
        title: "Congratulations to Ms. Neha Naijo Areekal",
        desc: "Ms. Neha Naijo Areekal, a Ph.D. scholar in Chemical Engineering, has been awarded the prestigious AFST(I) Travel Grant Award, along with a Springer voucher worth 300 euros, during the 30th Indian Convention of Food Scientists & Technologists, held at the D Y Patil University, School of Medicine, Navi Mumbai, from 19th to 21st December 2024."

    },
    {
        dt: "December",
        my: "",
        link: "",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna has been appointed as the Chairman of the International Road Federation (Global) Committee on Sustainable and Resilient Pavements. This esteemed committee will continue to address the numerous challenges faced by global roadway infrastructure."
    },
    {
        dt: "December",
        my: "",
        link: "",
        title: "Congratulations to Dr. Roshan Srivastava",
        desc: "Dr. Roshan Srivastava, Associate Professor of Civil and Environmental Engineering at IIT Tirupati, successfully chaired the recent Indo-US session. His leadership and expertise were instrumental in ensuring the event's resounding success."
    },
    {
        dt: "November",
        my: "",
        link: "",
        title: "Congratulations to Dr. Roshan Srivastava",
        desc: "Dr. Roshan Srivastava, Associate Professor in Civil and Environmental Engineering IIT Tirupati, Published a new book titled “Applications of Machine Learning in Hydroclimatology” as part of the Springer book series."
    },
    {
        dt: "November",
        my: "",
        link: "",
        title: "Congratulations to Dr. Roshan Srivastava",
        desc: "Dr. Roshan Srivastava, Associate Professor in Civil and Environmental Engineering IIT Tirupati, Invited to join the National GIS Academia Council of India (GACI) Task Force on 'Training'."
    },
    {
        dt: "November",
        my: "",
        link: "",
        title: "Congratulations to Mr. Mattaparthi Sri Gangadhar",
        desc: "Mr. Mattaparthi Sri Gangadhar, Ph.D. Scholar in Civil and Environmental Engineering, received the Best Young Scientist Oral Presentation Award at the International Conference on Resource Sustainability (icRS) 2024, held on November 7, 2024, in Bangkok, Thailand."
    },
    {
        dt: "November",
        my: "",
        link: "",
        title: "Congratulations to Mr. Likesh Kumar",
        desc: "Mr. Likesh Kumar (CY23M005), a Master of Science student, has been selected to attend the 74th Lindau Nobel Laureate Meeting in Lindau, Germany, from June 29 to July 4, 2025."
    },
    {
        dt: "September",
        my: "",
        link: "",
        title: "Congratulations to Prof. Muthukumar Palanisamy",
        desc: "Prof. Muthukumar Palanisamy, Professor in Mechanical Engineering IIT Tirupati, has been appointed Assistant Subject Editor for the International Journal of Hydrogen Energy, a prestigious Q1 journal in the field of hydrogen energy."
    },
    {
        dt: "September",
        my: "",
        link: "",
        title: "Congratulations to Dr. Ramesh Patel",
        desc: "Dr. Ramesh Patel, Assistant Professor in Electrical Engineering IIT Tirupati, has been elevated to Senior Member Status of IEEE."
    },
    {
        dt: "September",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Dr_Rahul_Innovations_in_Special_Concrete.png",
        title: "Congratulations to Dr. A. V. Rahul",
        desc: "Dr. A. V. Rahul, Assistant Professor in Civil and Environmental Engineering IIT Tirupati, received the Indian Concrete Institute award (31st annual award) under the 'Innovations in Special Concrete' category. The award is for the design of a special type of self-compacting concrete for the sloping roof construction in the iconic building of IISER Tirupati."
    },
    {
        dt: "September",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Dr_Roshan_National_Geospatial_Faculty.png",
        title: "Congratulations to Dr. Roshan Srivastav",
        desc: "Dr. Roshan Srivastav, Associate Professor in Civil and Environmental Engineering IIT Tirupati, received the 'National Geospatial Faculty Fellow Award' under the National Geospatial Awards 2024 an initiative of the FOSSEE project, IIT Bombay on 15th September 2024."
    },
    {
        dt: "September",
        my: "",
        link: "",
        title: "Congratulations to Ms. M.S.V. Naga Jyothi",
        desc: "Ms. M.S.V. Naga Jyothi, Ph.D. Scholar (Civil & Environmental Engineering) received the  'ACS Best Poster Award' at the '12th Asian Conference on Nanoscience and Nanotechnology' held on 23-25 September 2024 at IIT Madras, India. The IIT Madras and the Asian Research Network, Korea, jointly organized the conference."
    },
    {
        dt: "September",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Krishna_Prapoorna_Award.png",
        title: "Congratulations to Prof. B. Krishna Prapoorna",
        desc: "Prof. B. Krishna Prapoorna, Professor in Civil and Environmental Engineering IIT Tirupati, has recieved the Institution of Engineering and Technology (IET) India Mobility Award 2024, for extraordinary contributions to the landscape of Indian Engineering and Technology, in Bangalore."
    },
    {
        dt: "August",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Grant_Certificate_548795.pdf",
        title: "Congratulations to Prof. Thamida Sunil Kumar",
        desc: "Prof. Thamida Sunil Kumar, Professor, Department of Chemical Engineering, and Mr.V.R. Srikumar, Prof. Vasudharani Devanathan, Ms. Harshini Chakravarthyon; has been granted to the patentee for an invention entitled 'A THERMAL STERILIZER FOR AIR LADEN WITH CORONAVIRUS'."
    },
    {
        dt: "August",
        my: "",
        link: "",
        title: "Congratulations to Prof. Raghuramaraju",
        desc: "Prof. Raghuramaraju, Professor, Department of Humanities and Social Sciences (HSS), on being offered the Mahatma Gandhii Prestigious Chair at Panjab University."
    },

    {
        dt: "July",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Dipayan_Poster_Award.png",
        title: "Congratulations to Mr. Dipayan Chakraborty",
        desc: "Mr. Dipayan Chakraborty, PhD Scholar at Mechanical Engineering IIT Tirupati working with Dr. Ajay Kumar got the Best Poster Award at 16th International Conference on Creep and Fracture of Engineering Materials and Structures (CREEP 2024) IISc Bangalore 30th July 2024."
    },
    {
        dt: "July",
        my: "",
        link: "#",
        title: "Congratulations to Mr. S.M. Allabakshi",
        desc: "Mr. S.M. Allabakshi's PhD thesis work from the Department of Civil and Environmental Engineering has been selected for the prestigious global competition 'JWPE 3-Minute Pitch - My Life in Water' by the editorial team of the Journal of Water Process Engineering, Elsevier, recognizing it as one of the best Ph.D. thesis works globally in the area of water treatment technology (Supervisors: Dr. Shihabudheen M. Maliyekkal and Dr. Reetesh K. Gangwar)."
    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/best_thesis_award_Dr_Uthradevi.pdf",
        title: "Congratulations to Dr. Uthradevi Kannan",
        desc: "Dr. Uthradevi Kannan received the best Ph.D. Thesis Award and First Dean's Prize for her thesis titled 'A resource-efficient and waste-free point-of-use disinfection system' at the fifth convocation held on 22nd February 2024 (Thesis supervisor: Dr. Shihabudheen M. Maliyekkal, Department of Civil and Environmental Engineering, IIT Tirupati)."
    },

    {
        dt: "June",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/VivekGupta.png",
        title: "Congratulations to Mr. Vivek Gupta",
        desc: "Mr. Vivek Gupta, Ph.D. Research Scholar from the Department of Chemical Engineering got the Honourable Mention Graduate Student Poster Competition Award at the 26th Food Innovation Asia Conference 2024 at BITEC, Bangkok, Thailand."
    },
    {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/BPA_Naga_Jyothi.png",
        title: "Congratulations to Ms. M.S.V. Naga Jyothi",
        desc: "Ms. M.S.V. Naga Jyothi, Ph.D. Scholar (Civil & Environmental Engineering) received the 'Best Presentation Award' for the Oral Presentation at the '14th International Conference on Environmental Engineering and Applications (ICEEA 2024) on 24-26 April 2024 at 'Universidad Politécnica de Madrid', Spain."
    },

    {
        dt: "April",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Mamilla Ravi Sankar",
        desc: "Prof. Mamilla Ravi Sankar, Professor (Mechanical Engineering) nominated as Associate Editor, Journal of Manufacturing Processes (Elsevier). This is one of the top Manufacturing Journals."
    },

    {
        dt: "March",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Based on his teams research contributions in the areas of roadway noise and modeling, has been appointed an 'International Member of the USNAE Transportation Research Board Standing Committee' on Transportation-Related Noise and Vibration: 2024-27."
    },
    {
        dt: "March",
        my: "",
        link: "#",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Elected as 'Fellow of the Institution of Engineers(India)', March 2024."
    },

    {
        dt: "March",
        my: "",
        link: "https://www.ismarti.org/",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Appointed as 'iSMARTi Vice President of South Asia'. ISMARTi: International Society for Maintenance And Rehabilitation of Transport infrastructures"
    },
    {
        dt: "March",
        my: "",
        link: "https://www.ismarti.org/",
        title: "Congratulations to Prof. Krishna Prapoorna",
        desc: "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Appointed as 'iSMARTi Vice President of South Asia'. ISMARTi: International Society for Maintenance And Rehabilitation of Transport infrastructures"
    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Dr.Ajay_Chandran_Menon_Memorial_Award.pdf",
        title: "Congratulations to Dr. Ajay Kumar",
        desc: "Dr. Ajay Kumar, Associate Professor (Mechanical Engineering Department) received the 'Chandran Menon Memorial Award' for Applied Research & Innovative Technology for 2022 - 23. The award was given in the 72nd INDIAN FOUNDRY CONGRESS(IFC) on 2nd February 2024, at BIEC, Bengaluru, Karnataka."
    },
    {
        dt: "January",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2024/Vikas_Kumar_BPA.pdf",
        title: "Congratulations to Mr. Vikas Kumar Sahu",
        desc: "Mr. Vikas Kumar Sahu, Ph.D. Scholar (Physics Department) received “Best Poster Presentation Award” from International Conference on Highly Frustrated Magnetism 2024 organized by IIT Madras from 7 - 13 January 2024."
    }


];


export default NewsList2024;
